import React from 'react';

import Surgeries from '../../components/surgeries';

import { Swiper, SwiperSlide } from 'swiper/react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import Layout from '../../containers/layout';
import SEO from '../../components/seo';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import Review from '../../components/review';

import * as styles from '../../styles/pages/index.module.css';
import * as sharedStyles from '../../styles/shared.module.css';

const IndexPageTemplate = (props) => {
  const { data, isEn = false } = props;
  const { site } = data;
  const prefix = isEn ? '_en' : '';
  const surgeryTypes = data.surgeryTypes.nodes;
  const reviews = data.reviews.nodes;

  const width = typeof window === 'undefined' ? 1920 : document.body.clientWidth;

  // We need to duplicate videos to have enough for the slider
  const dupedVideos = [...data.videos.nodes, ...data.videos.nodes, ...data.videos.nodes];

  let models = data.modelPhotos.nodes
    .sort((a, b) => a.photo.asset.gatsbyImageData.height - b.photo.asset.gatsbyImageData.height)
    .reverse();

  if (width < 992 && (models.length / 2) % 2 === 1) {
    models = models.slice(1, -1);
  }

  const columnsCount = width > 992 ? 3 : 2;
  const heights = new Array(columnsCount).fill(0);
  const columns = Array.from({ length: columnsCount }, () => []);

  models.forEach((model) => {
    const shortestColumnIndex = heights.reduce((minIndex, height, index) => {
      return height < heights[minIndex] ? index : minIndex;
    }, 0);
    heights[shortestColumnIndex] += model.photo.asset.gatsbyImageData.height;
    columns[shortestColumnIndex].push(model);
  });

  for (let i = 0; i < columnsCount; i++) {
    const current = columns[i];
    let left = [...current];
    let prevHeight = i
      ? columns[i - 1][0].photo.asset.gatsbyImageData.height
      : models.at(-1).photo.asset.gatsbyImageData.height;
    const loopOut = [];
    while (left.length > 0) {
      const leftLength = left.length;
      for (let i = left.length - 1; i >= 0; i--) {
        const item = left[i];
        if (item.photo.asset.gatsbyImageData.height !== prevHeight) {
          delete left[i];
          prevHeight = item.photo.asset.gatsbyImageData.height;
          loopOut.push(item);
        }
      }
      left = left.filter((item) => item !== undefined);
      if (leftLength === left.length) {
        loopOut.push(...left);
        break;
      }
    }
    columns[i] = loopOut;
  }

  const out = [];
  for (let i = 0; i < columns[0].length; i++) {
    for (let j = 0; j < columnsCount; j++) {
      out.push(columns[j][i]);
    }
  }

  return (
    <Layout isEn={isEn}>
      <SEO
        title={site.title || site.title_en}
        description={site.description || site.description_en}
        keywords={site.keywords || site.keywords_en}
      />
      <section className={styles.promo}>
        <StaticImage
          objectFit="contain"
          className={styles.promoImage}
          src="../../media/Victoria.png"
          alt="Виктория Пластический Хирург"
        />
        <div className={styles.padding}>
          <p className={styles.bluetext}>
            {isEn
              ? 'Plastic surgeon, Doctor of Medical Sciences, Professor'
              : 'Пластический хирург, Доктор медицинских наук, профессор'}
          </p>
          <h1 className={styles.name}>{site.surgeonName}</h1>
          <p className={styles.desc}>
            {isEn
              ? 'Plastic surgeon; Doctor of Medical Sciences; Professor of the course of reconstructive-plastic surgery of the State Budgetary Institution of Medical and Biomedical Institution "Vladimirsky MONIKI"; oncologist, maxillofacial surgeon of the medical centre "Skin Clinic"; plastic surgeon of the medical centre "Hartman Clinic"; Member of the Russian Society of Plastic, Reconstructive and Aesthetic Surgeons and Cosmetologists; member of the European Association of Cranio-Maxillofacial Surgeons; author of more than 90 printed works and 12 patents for invention.'
              : 'Пластический хирург; доктор медицинских наук; профессор курса реконcтруктивно-пластической хирургии ГБУЗ МО МОНИКИ им. М. Ф. Владимирского; врач-онколог, челюстно-лицевой хирург медицинского центра «Клиника кожи»; пластический хирург медицинского центра «Клиника Хартман»; Член Российского общества пластических, реконструктивных и эстетических хирургов и косметологов; член европейской ассоциации черепно-челюстно-лицевых хирургов; автор более 90 печатных работ и 12 патентов на изобретение.'}
          </p>
          <p className={styles.desc}>
            {isEn ? (
              <>
                <span>Founder of the </span>
                <a
                  className={styles.ceroxinLink}
                  target="blank"
                  rel="noopener noreferrer"
                  href="https://ceroxin.com/"
                >
                  Ceroxin
                </a>
                <span>
                  {' '}
                  project. Repeated participant of international conferences, symposiums on plastic
                  surgery and cosmetology, maxillofacial surgery, oncology. Work experience since
                  2004.
                </span>
              </>
            ) : (
              <>
                <span>Основатель проекта </span>
                <a
                  className={styles.ceroxinLink}
                  target="blank"
                  rel="noopener noreferrer"
                  href="https://ceroxin.com/"
                >
                  Ceroxin
                </a>
                <span>
                  . Неоднократный участник международных конференций, симпозиумов по пластической
                  хирургии и косметологии, челюстно-лицевой хирургии, онкологии. Стаж работы с 2004
                  года.
                </span>
              </>
            )}
          </p>
          <div className={styles.buttons}>
            <button
              className="filled"
              onClick={() =>
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
              }
            >
              {isEn ? 'Make an appointment' : 'Записаться'}
            </button>
            <Link to={isEn ? '/en/about' : '/about'}>
              <button>{isEn ? 'About me' : 'Обо мне'}</button>
            </Link>
          </div>
        </div>
        <div className={styles.numbersDecor}>
          <div className={styles.numbers}>
            <div className={styles.numberPart}>
              <h3>20</h3>
              <p>{isEn ? 'years of practice' : 'лет практики'}</p>
            </div>
            <div className={styles.numberPart}>
              <h3>13000+</h3>
              <p>{isEn ? 'happy clients' : 'счастливых клиентов'}</p>
            </div>
            <div className={styles.numberPart}>
              <h3>12</h3>
              <p>{isEn ? 'development patents' : 'патентов на изобретение'}</p>
            </div>
            <div className={styles.numberPart}>
              <h3>90+</h3>
              <p>{isEn ? 'printed works' : 'печатных работ'}</p>
            </div>
          </div>
        </div>

        <div className={styles.decor}>
          <h2>Plastic Surgeon</h2>
        </div>
      </section>
      <section className={styles.video}>
        <Swiper
          slidesPerView={width > 690 ? 5 : 3}
          spaceBetween={-100}
          speed={200}
          loopAdditionalSlides={5}
          centeredSlides={true}
          loop={true}
          slideToClickedSlide={true}
          initialSlide={2}
        >
          {dupedVideos.map((video, i) => {
            return (
              <SwiperSlide className={styles.videoSlide} key={i}>
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  src={video.video.asset.url}
                  className={styles.videoPlayer}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>
      <div className={styles.surgeriesFooter}>
        <h2 className={sharedStyles.sectionTitle}>{isEn ? 'Surgeries' : 'Операции'}</h2>
      </div>
      <Surgeries isEn={isEn} noBackground={true} surgeryTypes={surgeryTypes} id="indexSurgeries" />
      <div className={styles.surgeriesFooter}>
        <Link className="link-no-decoration" to={isEn ? '/en/surgeries' : '/surgeries'}>
          <button>{isEn ? 'See all' : 'Смотреть все'}</button>
        </Link>
        <h2 className={sharedStyles.sectionTitle}>{isEn ? 'Reviews' : 'Отзывы'}</h2>
      </div>
      <section className={styles.reviews}>
        <Swiper
          slideToClickedSlide={true}
          slidesPerView={width > 500 ? Math.ceil(width / 500) + 0.2 : 1.3}
          spaceBetween={20}
        >
          {reviews.map((data, i) => (
            <SwiperSlide key={i}>
              <Review
                name={data['name' + prefix]}
                messages={data['reviewMessages' + prefix]}
                stars={data['reviewStars' + prefix]}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={styles.models}>
        <Masonry gutter="20px" sequential={true} columnsCount={width > 992 ? 3 : 2}>
          {out.map((model, i) => (
            <GatsbyImage
              key={i}
              style={{ width: '100%', display: 'block' }}
              image={model.photo.asset.gatsbyImageData}
              alt={model.photo.alt}
            />
          ))}
        </Masonry>
      </section>
    </Layout>
  );
};

export default IndexPageTemplate;
